import PermissionGuard from "@/components/PermissionGuard/PermissionGuard";
import React from "react";
import { Outlet, Route } from "react-router-dom";
import MainLayout from "../../components/MainLayout/MainLayout";
import CheckoutLayout from "../../components/CheckoutLayout/CheckoutLayout";
import { AuthenticationGuard } from "@/components/AuthenticationGuard/AuthenticationGuard";
import { SubscriptionCheckoutProvider } from "@/modules/subscriptions/features/SubscriptionCheckout/SubscriptionCheckoutContext";
import { TotalAccessLandingPage } from "@/modules/subscriptions/features/TotalAccess/components/TotalAccessLandingPage/TotalAccessLandingPage";
import SubscriptionCheckoutPage from "@/modules/subscriptions/features/SubscriptionCheckout/components/SubscriptionCheckoutPage/SubscriptionCheckoutPage";
import SubscriptionConfirmationPage from "@/modules/subscriptions/features/SubscriptionCheckout/components/SubscriptionConfirmationPage/SubscriptionConfirmationPage";

// Shared provider sits above both layouts so the chosen frequency
// survives navigation from the landing page → checkout page. Each layout
// renders <Outlet/> for its inner page.
const SubscriptionsRoot = () => (
  <SubscriptionCheckoutProvider>
    <Outlet />
  </SubscriptionCheckoutProvider>
);

const SubscriptionsMainLayout = () => <MainLayout section="subscriptions" />;
const SubscriptionsCheckoutLayout = () => <CheckoutLayout />;

const SubscriptionRoutes = (
  <Route element={<SubscriptionsRoot />} path="/subscriptions">
    {/* Landing — full app shell */}
    <Route
      element={<AuthenticationGuard component={SubscriptionsMainLayout} />}
    >
      <Route
        element={
          <PermissionGuard requiredPermissions={["shop-total-access"]}>
            <TotalAccessLandingPage />
          </PermissionGuard>
        }
        path=":slug"
      />
    </Route>

    {/* Checkout + confirmation — focused layout */}
    <Route
      element={<AuthenticationGuard component={SubscriptionsCheckoutLayout} />}
    >
      <Route element={<SubscriptionCheckoutPage />} path=":slug/checkout" />
      <Route
        element={<SubscriptionConfirmationPage />}
        path=":slug/confirmation/:subscriptionUuid"
      />
    </Route>
  </Route>
);

export default SubscriptionRoutes;
